<div class="editor">
  <div class="toolbar" *ngIf="!hideToolbar" [class.floating-toolbar]="floatingToolbar" role="toolbar"
    aria-label="Toolbar with button groups">
    <button type="button" (click)="executeCommand('undo')" title="Undo">
      <i class="fas fa-undo"></i>
    </button>
    <button type="button" (click)="executeCommand('redo')" title="Redo">
      <i class="fas fa-redo"></i>
    </button>
    <button type="button" (click)="executeCommand('bold')" title="Bold">
      <i class="fas fa-bold"></i>
    </button>
    <button type="button" (click)="executeCommand('italic')" title="Italic">
      <i class="fas fa-italic"></i>
    </button>
    <button type="button" (click)="executeCommand('strikethrough')" title="Strikethrough">
      <i class="fas fa-strikethrough"></i>
    </button>
    <button type="button" (click)="executeCommand('insertUnorderedList')" title="Unordered List">
      <i class="fas fa-list-ul"></i>
    </button>
    <button type="button" (click)="executeCommand('insertOrderedList')" title="Ordered List">
      <i class="fas fa-list-ol"></i>
    </button>
    <button type="button" (click)="executeCommand('justifyLeft')" title="Align Left">
      <i class="fas fa-align-left"></i>
    </button>
    <button type="button" (click)="executeCommand('justifyCenter')" title="Align Center">
      <i class="fas fa-align-center"></i>
    </button>
    <button type="button" (click)="executeCommand('justifyRight')" title="Align Right">
      <i class="fas fa-align-right"></i>
    </button>
    <button type="button" (click)="executeCommand('justifyFull')" title="Justify">
      <i class="fas fa-align-justify"></i>
    </button>
    <button type="button" (click)="addHyperlink()" title="Hyperlink">
      <i class="fas fa-link"></i>
    </button>
    <select id="format-block" [(ngModel)]="formatBlock" (change)="executeCommand('formatBlock', $event.target.value)"
      title="Format">
      <option value="P">Paragraph</option>
      <option value="H1">Heading 1</option>
      <option value="H2">Heading 2</option>
      <option value="H3">Heading 3</option>
      <option value="H4">Heading 4</option>
      <option value="H5">Heading 5</option>
      <option value="H6">Heading 6</option>
    </select>
    <select id="font-size" (change)="executeCommand('fontSize', $event.target.value)" title="Font Size">
      <option value="1">Very Small</option>
      <option value="2">Small</option>
      <option value="3">Normal</option>
      <option value="4" selected>Large</option>
      <option value="5">Very Large</option>
      <option value="6">Huge</option>
      <option value="7">Maximum</option>
    </select>
    <!-- <select id="font-name" (change)="executeCommand('fontName', $event.target.value)" title="Font Name">
    <option value="Arial">Arial</option>
    <option value="Courier New">Courier New</option>
    <option value="Georgia">Georgia</option>
    <option value="Helvetica">Helvetica</option>
    <option value="Lucida Sans">Lucida Sans</option>
    <option value="Tahoma">Tahoma</option>
    <option value="Times New Roman">Times New Roman</option>
    <option value="Trebuchet MS">Trebuchet MS</option>
    <option value="Verdana">Verdana</option>
    <option value="Roboto">Roboto</option>
  </select> -->
    <button class="color-picker" (click)="toggleColorPicker('text-color')" title="Text Color">
      <i class="fas fa-font"></i>
      <div class="color-display" id="text-color-display" [style.backgroundColor]="selectedTextColor"></div>
      <div class="color-options" id="text-color-options" *ngIf="showTextColorOptions">
        <div class="color-palette" id="text-color-palette">
          <div class="color-swatch" *ngFor="let color of colorPalette" [style.backgroundColor]="color"
            (click)="executeCommand('foreColor', color); showTextColorOptions = false"></div>
        </div>
      </div>
    </button>
    <button class="color-picker" (click)="toggleColorPicker('bg-color')" title="Background Color">
      <i class="fas fa-fill-drip"></i>
      <div class="color-display" id="bg-color-display" [style.backgroundColor]="selectedBgColor"></div>
      <div class="color-options" id="bg-color-options" *ngIf="showBgColorOptions">
        <div class="color-palette" id="bg-color-palette">
          <div class="color-swatch" *ngFor="let color of colorPalette" [style.backgroundColor]="color"
            (click)="executeCommand('backColor', color); showBgColorOptions = false"></div>
        </div>
      </div>
    </button>
    <input type="file" id="image-upload" accept=".jpg, .jpeg, .png, .gif" style="display: none"
      (change)="handleImageUpload($event)" />
    <button type="button" (click)="triggerImageUpload()" title="Image Upload">
      <i class="fas fa-image"></i>
    </button>
    <button type="button" (click)="floatingToolbar = !floatingToolbar" title="Floating">
      {{ floatingToolbar ? 'Unfloat' : 'Float' }}
    </button>
    <!-- <button type="button" (click)="executeCommand('indent')" title="Indent">
      <i class="fas fa-indent"></i>
    </button>
    <button type="button" (click)="executeCommand('outdent')" title="Outdent">
      <i class="fas fa-outdent"></i>
    </button> -->
  </div>

  <div class="text-area" id="text-area" contenteditable="true" (input)="updateWordCount($event)"
    (change)="updateWordCount($event)" (mouseup)="updateFontSizeDropdown(); getCurrentElementFocus()"
    (keyup)="updateFontSizeDropdown(); getCurrentElementFocus()"></div>

  <div class="word-count">
    Words: <span>{{ wordCount }}</span>
  </div>
</div>